export function urlEncodeB64 (runtime, buffer: Buffer) {
  const input = runtime.bufferEncodeBase64(buffer),
    urlSafeChars = {'+': '-', '/': '_', '=': ''}
  return input.replace(/[+/=]/g, m => urlSafeChars[m])
}
